<template>
  <div>
    <v-list>
      <v-list>
        <v-dialog v-model="showCreateDialog" v-if="isAdmin">
          <template #activator="{ props }">
            <v-list-item v-bind="props" link class="offwhite mx-5 my-2">
              <template #prepend>
                <v-icon>mdi-plus</v-icon>
              </template>
              <template #title>
                <span class="font-weight-bold mr-5" style="font-size: 1.3rem;">Add new Event</span>
              </template>
            </v-list-item>
          </template>
          <v-sheet>
            <CreateEvent @close="closeDialog"/>
          </v-sheet>
        </v-dialog>
        <div style="width:100%" class="d-flex justify-end px-5">
          <v-btn :loading="loading" x-small @click="getMyEvents">Refresh <v-icon x-small>mdi-refresh</v-icon></v-btn>
        </div>
      </v-list>
      <AdminEventListItem @delete="deleteEvent" v-for="event of events" :key="event.id" :event="event" @updateEvent="updateEvent"/>
    </v-list>
  </div>
</template>

<script>
import { getAllMyEvents } from "@/services/event.service";
import AdminEventListItem from "@/components/management/events/AdminEventListItem";
import CreateEvent from "@/components/event/CreateEvent";

export default {
  name: "AdminEventList",
  components: { CreateEvent, AdminEventListItem },
  data() {
    return {
      events: [],
      showCreateDialog: false,
      loading: false,
    };
  },
  created() {
    this.getMyEvents();
  },
  computed: {
    isAdmin() {
      return this.currentUser.roles.includes("ROLE_ADMIN");
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    closeDialog() {
      this.showCreateDialog = false;
    },
    deleteEvent(id) {
      this.events.splice(this.events.findIndex(x => x.event.id === id), 1);
    },
    updateEvent(event) {
      let index = this.events.findIndex(x => x.event.id === event.id);
      this.events[index].event = event;
      this.$set(this.events, index, this.events[index]);
    },
    async getMyEvents() {
      this.loading = true;
      this.events = await getAllMyEvents();
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>